import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onInvoicesDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onInvoicesDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="invoice"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onInvoicesDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
